import axios, { AxiosStatic, AxiosInstance } from 'axios';
import { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import { IApiSettings, IHttpRequest, IHttpResponse, IHttpResponseHandler, IStringDictionary, IExternalAuth } from '../interfaces/IHttp';


class OAuth implements IExternalAuth {

    private readonly apiSettings: IApiSettings;

    public fetchImpl: (input: RequestInfo, init?: RequestInit) => Promise<Response>;

    constructor(apiSettings: IApiSettings) {
        this.apiSettings = apiSettings;
    }

    private getFetchImpl() {
        return this.fetchImpl || fetch;
    }

    public getToken = () => {
        return localStorage.getItem('token');
    }

    public setToken = (username: string, password: string) => {

        return new Promise<void>((resolve, reject) => {

            var params: IStringDictionary = {
                username: username,
                password: password,
                grant_type: "password",
                client_id: "ro.client",
                client_secret: "secret"
            };

            this.getFetchImpl()(this.apiSettings.authTokenUrl(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: Object.keys(params).map((key) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
                }).join('&')
            }).then(response => {

                try {
                    response.json().then(function (data) {

                        if (!data.hasOwnProperty('access_token')) {
                            reject();
                        }

                        localStorage.setItem('token', data['access_token']);

                        resolve();
                    });
                } catch{
                    reject();
                }
            }).catch(error => reject());
        });

    }
}

export { OAuth };